export default "__VITE_ASSET__Bz$tg2AL__"